<script setup lang="ts">
import { sub } from "date-fns";
import type { Period, Range } from "~/types";

const { isNotificationsSlideoverOpen, isGarnmentSlideoverOpen } =
  useDashboard();

import { dragAndDrop } from "@formkit/drag-and-drop/vue";

import { animations } from "@formkit/drag-and-drop";
const items = [
  [
    {
      label: "New mail",
      icon: "i-heroicons-paper-airplane",
      to: "/inbox",
    },
    {
      label: "New user",
      icon: "i-heroicons-user-plus",
      to: "/users",
    },
  ],
];

const garments = ref([
  {
    id: 1,
    imageUrl: "/jacket2.png",
    name: "Stylish Jacket",
    price: "$99.99",
    key: "jacket",
  },
  {
    id: 2,
    imageUrl: "/armani.png",
    name: "Casual Shirt",
    price: "$49.99",
    key: "shirt",
  },
  {
    id: 3,
    imageUrl: "/armani3.png",
    name: "Elegant Dress",
    price: "$129.99",
    key: "armani",
  },
  {
    id: 4,
    imageUrl: "/shirt3.png",
    name: "Shirt Stripe",
    price: "$79.99",
    key: "shirts",
  },
]);
const listRef = ref();

dragAndDrop({
  parent: listRef,
  values: garments,
  group: "garments",
  // sortable: true,
  // dropZone: true,
  // dropZoneClass: "dragging",
  // draggingClass: "dragfly",
  plugins: [animations()],
});

const range = ref<Range>({
  start: sub(new Date(), { days: 14 }),
  end: new Date(),
});
const period = ref<Period>("daily");
</script>

<template>
  <UDashboardPage>
    <UDashboardPanel grow>
      <UDashboardNavbar title="Gallery">
        <template #right>
          <UButton
            color="gray"
            variant="ghost"
            square
            @click="isGarnmentSlideoverOpen = true"
          >
            <UIcon name="i-heroicons-squares-plus" class="w-5 h-5" />
          </UButton>
          <div class="w-[200px]">
            <UserDropdown2 />
          </div>
        </template>
      </UDashboardNavbar>

      <UDashboardPanelContent>
        <!-- ~/components/home/HomeChart.vue -->
        <UDashboardToolbar class="pb-4 px-1.5 overflow-x-auto mb-4">
          <UBreadcrumb
            divider="/"
            :links="[
              { label: 'All garments', to: '/' },
              { label: 'Suits', to: '/' },
              { label: 'Shirts' },
            ]"
          />
          <UButton
            icon="i-heroicons-plus"
            size="sm"
            variant="outline"
            label="Add folder"
          />
        </UDashboardToolbar>
        <div
          class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-8 gap-3"
          ref="listRef"
        >
          <UCard
            v-for="garment in garments"
            :key="garment.key"
            :ui="{
              background: 'dark:bg-[#1e1f21]',
              ring: 'ring-0',
              base: 'rounded-lg overflow-hidden',
              body: 'px-0 py-0',
            }"
          >
            <!-- Photo of the garment -->
            <div class="h-40">
              <img
                draggable="false"
                :src="garment.imageUrl"
                alt="Garment Photo"
                class="object-cover w-full h-full p-0 dark:bg-[#1e1f21]"
              />
            </div>

            <!-- Garment data in the footer -->
            <template #footer>
              <div class="p-0">
                <p class="text-gray-600 text-xs">{{ garment.price }}</p>
                <h3 class="text-[9px] font-semibold">{{ garment.name }}</h3>
              </div>
            </template>
          </UCard>
        </div>
      </UDashboardPanelContent>
    </UDashboardPanel>
  </UDashboardPage>
</template>
